import React from 'react'
import {useTranslation} from 'react-i18next'
import {observer} from 'mobx-react'
import {Col, Divider, Row, Typography, Button} from 'antd'
import {CopyLink, Icon} from '@/components'
import {ShareButtons} from '@/pages/components'
import {LinkDetailsModalFooterProps} from './props'
import styles from './styles.scss'
import {PayByLinkStatus} from '@/constants'
import {isShareButtonsShown} from '@/constants/payment-link-share-state'

const {Text} = Typography

export const LinkDetailsModalFooter: React.FC<LinkDetailsModalFooterProps> = observer(({store}) => {
    const {t} = useTranslation()
    const {isMultiUse, paymentLink} = store
    const {status, url} = paymentLink

    const isShareShown =
        (status === PayByLinkStatus.viewed ||
                status === PayByLinkStatus.active ||
                status === PayByLinkStatus.attempted) &&
            isShareButtonsShown
    return (
        <div className={styles.container}>
            <Row className={styles.row}>
                <Col className={styles.flex} xs={isMultiUse ? 16 : 20}>
                    <Text className={styles.title}>{t('LinkDetailsModalFooter.copyLink')}</Text>
                </Col>

                {isMultiUse && (
                    <>
                        <Col className={styles.flex} xs={1}></Col>
                        <Col className={styles.flex} xs={3}>
                            <Text className={styles.title}>
                                {t('PaymentLinkDownloadPdfButton.downloadQr')}
                            </Text>
                        </Col>
                    </>
                )}

                {isShareShown ? (
                    <>
                        <Col className={styles.flex} xs={1}></Col>
                        <Col className={styles.flex} xs={3}>
                            <Text className={styles.title}>
                                {t('LinkDetailsModalFooter.shareVia')}
                            </Text>
                        </Col>
                    </>
                ) : null}
            </Row>
            <Row className={styles.row}>
                <Col xs={isMultiUse ? 16 : 20}>
                    <CopyLink url={url} />
                </Col>

                {isMultiUse && (
                    <>
                        {' '}
                        <Col xs={1} className={styles.divider}>
                            <Divider type={'vertical'} />
                        </Col>
                        <Col xs={3}>
                            <Button
                                type='primary'
                                className={styles.button}
                                icon={<Icon className={styles.icon} type='qr' />}
                                onClick={() => (store.widgetType = 'downloadPdf')}
                            />
                        </Col>
                    </>
                )}

                {isShareShown ? (
                    <>
                        <Col xs={1} className={styles.divider}>
                            <Divider type={'vertical'} />
                        </Col>
                        <Col className={styles.flex} xs={3}>
                            <ShareButtons
                                onEmailClick={() => (store.widgetType = 'shareViaEmail')}
                                onSmsClick={() => (store.widgetType = 'shareViaSMS')}
                            />
                        </Col>
                    </>
                ) : null}
            </Row>
        </div>
    )
})
